<template>
    <div class="snap-paper-result master-nav-wrap-container">
        <SidebarTableLayout>
            <template #main>
                <main data-mfe-id="npl-body.patsnap" />
            </template>
        </SidebarTableLayout>
    </div>
</template>

<script lang="ts">
// @ts-nocheck
import { psAxios } from '@patsnap/common-ps-http';
import { loadMicroApp, prefetchApps } from 'qiankun';
import SidebarTableLayout from '@/components/view-layouts/sidebar-table.vue';
import TopSwitch from '@/components/view-layouts/TopSwitch.vue';
import Vue from 'vue';
import { RavenInsertMeta } from 'library-@/services/sentry';
import nplSearchResultInitInstance from '@/services/deprecated-npl-search-result-init';
import { replaceWhiteLabelTitle } from 'library-@/utils/replaceWhiteLabelTitle';
import { headerService } from '@/services/header-service';

const appName = 'npl-body.patsnap';
// const { version } = require('../../../../../../analytics-npl/package.json');
const nplMfeEntry = `${process.env['VUE_APP_STATIC_COMMON_URL']}/${appName}/index.html`;

// 22.5.0锁死版本
// const nplMfeEntry = `${process.env['VUE_APP_STATIC_COMMON_URL']}/${appName}/22.3.0/index.html`;
// const nplMfeEntry = `http://localhost:9001/${appName}/24.12.1/?noCache=${Date.now()}`;

window.qiankunSingleton = window.qiankunSingleton || {
    loadMicroApp,
    prefetchApps,
};


const TopSwitchComponent = Vue.extend(TopSwitch);

export default {
    name: 'PaperResultShell',
    components: {
        SidebarTableLayout,
    },
    created() {
        nplSearchResultInitInstance.updatePageSetting();
        // backUpHeaderConfig = window.$bridge.store.read('headerConfig');
    },
    mounted() {
        console.log(this.$route);
        const container = `[data-mfe-id="${appName}"]`;
        /* '/search/paper-result/' */
        let appRoutePathBase = '/search/paper-result/';
        // FIXME: dirty code for all in one
        if (window.___location) {
            appRoutePathBase = `${window.___location.proxied_base}${appRoutePathBase}`;
        }

        headerService.deferred.promise
            .then(() => {
                document.title = replaceWhiteLabelTitle({
                    title: this.$t('app.nplTitle'),
                    isWhiteLabel: headerService.account?.whiteLabel || false,
                });
            });

        this.micro = window.qiankunSingleton.loadMicroApp({
            name: appName,
            entry: nplMfeEntry,
            container: this.$el.querySelector(container),
            props: {
                // 类型声明见 packages/analytics-npl/src/type/common.ts
                lang: this.$i18n.locale,
                routeBaseUrl: appRoutePathBase,
                psAxios,
                ravenInsertMetaHook: RavenInsertMeta,
                slotCallbacks: {
                    TopSwitch: mountPoint => {

                        const topSwitch = new TopSwitchComponent({});
                        console.log('TopSwitch mountPoint', topSwitch, mountPoint);
                        topSwitch.$mount(mountPoint);
                    },
                },
            },
        });
    },
    beforeDestroy() {
        this.micro ? this.micro.unmount() : null;
    },
};

if (window.location.search.includes('with_paper=true')) {
    window.qiankunSingleton.prefetchApps([
        {
            name: appName,
            entry: nplMfeEntry,
        },
    ]);
}
</script>

<style lang="scss">
[data-mfe-id='npl-body.patsnap'] {
    flex: 1;
    flex-shrink: 0;
    .mainform,
    .left-refine-result-wrap {
        max-height: calc(100vh - 64px);
        overflow-y: auto;
    }
}
</style>
